module.exports = __webpack_public_path__ + "img/shield.d467a02f.svg";